// extracted by mini-css-extract-plugin
export default {"noQuotes":"styles_noQuotes__QgrzT","noQuotesText":"styles_noQuotesText__Ci4Mk"};